import { InternationalisationService } from "../../forked/angular-internationalisation";
import Utils from "../utils";
import { AccountingCustomerDataModel } from "./accountPayment.model";
import { DataModel, SyncModel, SyncDataModel } from "./syncModel";
import { AddressType } from "./userInfo.model";
import * as moment from "moment";
import { ContentType, ImageOrientation } from "../contentTypes";
import { OrdertypeSettings } from "./ordertype.model";
import { IMenuCourse } from "../../components/basket/basket.facade";
import { Community, CommunityRaw } from "../../components/mainNav/mainnav.service";
import { IEvent } from "../../services/eventmanager.service";

// ViewModels
/**DropDownList viewModel */
export class DDLViewModel {
  public get key(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.keyEN) ? this.keyDE : this.keyEN;
  }
  public keyEN: string;
  public keyDE: string;
  public value: string;
  /** Sonderfall, wenn der aktuelle Tag hinzugefügt werden musste für die Auswahl, aber selbst geschlossen ist.
   * Es gibt den fall, dass durch das Füllen der DDL zumindest ein eintrag generiert werden musste.
   */
  public is_closed: boolean = false;
  /** Sonderfall, wenn die Uhrzeit bei dem Tag berücksichtigt werden muss.
   * Bei Vorlaufzeit in Tagen, muss nach 24 uht der tag berücksichtigt werden. 
   */
  public use_time: boolean = false;
}

export class WebshopOrderDataViewModel {
  public name: string; // max length 30
  public fname: string; // max length 30
  public prefix: string; // max length 10
  public email: string; // max. 63
  public bday_ymd: number;
  public zip_code: string; // max length 10
  public co: string; // max. 30
  public address: string; // max. 40
  public addition: string; // max. 25
  public city: string; // max. 30
  public country: string; // max. 30
  public telephone1: string; // max. 20, privat
  public telephone2: string; // max. 20, geschäftlich
  public telephone_mobile: string; // max. 20
  public furtherAddresses: FurtherAddressViewModel[];
}

export class FurtherAddressViewModel {
  public id: string; // id as token
  public address_type: AddressType;
  public co: string; // max. 30
  public address: string; // max. 40
  public addition: string; // max. 25
  public zip_code: string; // max. 10
  public city: string; // max. 30
  public country: string; // max. 30
  public mobilePhone: string; // max. 20
  public selected: boolean;
}

export class CustomerInputFieldViewModel {
  public fieldName: string;
  public fieldType: string;
  public isRequired: boolean;
  public value: string;
}

export const MAX_BASKETITEM_COUNT = 99;

export class BasketItemViewModel {
  /** pseudoid, wird im Warenkorb verwendet zur eindeutigen zuordnung.
   * Achtung! es kann null sein, wenn noch kein Platz im Warkorb bekannt ist. Es muss beim Hinzufügen ermittelt werden
   */
  public id: number | null;
  /** id of the product (ProductDataModel) */
  public product_id: number;
  /** id of the pos product */
  public pos_product_id: number;
  public labelDE: string;
  public labelEN: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.labelEN) ? this.labelDE : this.labelEN;
  }
  public imageUrl: string;
  public hasImage: boolean;
  public time_set: number;
  public scheduled_to_hms: number;
  public scheduled_from_hms: number;

  /** count of the product */
  private itemcount: number = 1; // 
  public get count(): number {
    return this.itemcount;
  }
  public set count(count: number) {
    if (count > MAX_BASKETITEM_COUNT) {
      console.warn("Count is bigger than max count.", count, MAX_BASKETITEM_COUNT);
    }
    this.itemcount = Math.max(Math.min(count, MAX_BASKETITEM_COUNT), 0);
  }
  /** extras for the product */
  public product_extras: BasketItemExtraViewModel[] = [];
  /** Kommentar */
  public comment: string = "";
  /** Price from best Pricelevel includes variablePrice */
  public basePrice: number;
  /** Deposit from best Pricelevel */
  public deposit: number;
  /** basePrice with applied best discount limited by noDiscount and minDiscount */
  public price: number;
  public vatPercent: number;

  public servicePe: number | null;
  public userPe: number | null;
  public appliedDiscount: number;

  public noDiscount: boolean;
  public minDiscountPrice: number;
  public fallbackPrices: BasketItemPriceViewModel;
  public pePrices: { [pe: number]: BasketItemPriceViewModel } = {};

  // extra Webgutschein Information
  /** Webgutschein ID  */
  public webvoucher_id: number;
  /** Versandart */
  public delivery_type: deliveryTypes;
  /** Versandart im Warenkorb darstellen */
  public show_delivery_type: boolean;
  /** Personenanzahl */
  public person_count: number;
  /** Personenanzahl im Warenkorb darstellen */
  public show_person_count: boolean;
  /** Prüfung es es sich um einen Webgutschein handelt */
  public get isWebvoucher(): boolean {
    return this.usingtype == -4 /*UsingType.VariableWebvoucher*/ || this.usingtype == 4 /*UsingType.Webvoucher*/;
  }

  /** if variable price, the entered price */
  public variable_price: number;
  /** entered date for a ticket */
  public valid_date: number;
  public usingtype: number /*UsingType*/;
  public wgrGroupId: number;
  /** Vorlage Menügang (0=ohne) */
  public default_menucourse: number = 0;
  /** Gewählter Menügang (0=ohne) */
  public menucourse: number = 0;
  /* Referenz auf den Buchenden Gast */
  public cus_ref_id: number | null;

  public bonusactionId?: number;
  public benefitId?: number;
  public benefitProductId?: number;
  public benefitLossId?: number;
  public benefitCostPoints?: number;
  public coupon_id?: number | string;
  public coupon_code?: number | string;
  public redemption_id?: number;
}

export class BasketItemPriceViewModel {
  public price: number;
  public priceWithDefaultExtras: number;
  public deposit: number;
  public vat: number;
  public extraPrices: { [extraID: number]: BasketItemExtraPriceViewModel } = {};
}

export class BasketItemExtraPriceViewModel {
  public price: number;
  public deposit: number;
}

export class BasketItemExtraViewModel {
  /** id of the product (ProductExtraDataModel) */
  public product_extra_id: number;
  /** id of the pos product */
  public pos_product_id: number;
  /** pos RezID */
  public pos_rez_id: number;
  /** Extra ist ein echter Artikel, sonst ist es nur eine Information */
  public get is_real_product(): boolean {
    return !(this.pos_rez_id == -1 && this.product_extra_id < 0 && this.pos_product_id < 0);
  }
  public get title(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.titleEN) ? this.titleDE : this.titleEN;
  }
  public titleDE: string;
  public titleEN: string;
  public subIndex: number; // Extra with subindex x > 0 is Parent to every Extra Subindex -x
  public count: number; // count of the product extra
}

/** Pfand Darstellungs Art */
export enum DepositView {
  /** Darstellung erst im Warenkorb */
  AddInBasket = 0,
  /** Darstellung bereits in der Artikelliste */
  AddInArticlelist = 1
}

/** Zahlungspartner */
export enum paymentPartners {
  allUnknown = 0,
  Hypersoft = 1,
  HypersoftCustomer = 2,
  Concardis = 3,
  adyen = 4,
  AFC = 5,
  elPAY = 6,
  wallee = 7
}

/** Bestellarten:
 * AllUnknown = 0
 * Pickup = 1
 * Delivery = 2
 * InHouse = 3
 * OrderAhead = 4
 * ExternalBasket = 5
 * Retail = 6
 * Ticket = 7
 * Webvoucher = 8
 * PickupGroup = 9
  * DeliveryGroup = 10
 */
export enum orderTypes {
  allUnknown = 0,
  pickup = 1,
  delivery = 2,
  inHouse = 3,
  orderAhead = 4,
  externalBasket = 5,
  retail = 6,
  ticket = 7,
  webvoucher = 8,
  pickupGroup = 9,
  deliveryGroup = 10,
}

/** Versandart für Gutscheine */
export enum deliveryTypes {
  /** print@home download */
  download = 0,
  /** Post versand*/
  post = 1,
}

/** TimeSetDay */
export enum TimeSetDay {
  /** Bei Feiertag sind die Holidays zu verwenden, nicht de Wochentag */
  Holiday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7,
  BeforeHoliday = 8,
}

/** Versandoptionen von Webgutscheinen */
export enum WebvoucherDeliverySettings {
  /** print@home erlaubt es eine PDFherunterzuladen und selbst zu drucken */
  PrintAtHome = 0,
  /** Ein gedruckter Webgutschein wird per Post zugestellt */
  Post = 1,
  /** Gast kann zwischen print@home und Post wählen */
  PrintAtHomeOrPost = 2,
}

/** interner Status der Bestellung */
export enum orderStatus {
  /** Angelegt und noch nicht verarbeitet, muss ignoriert werden */
  none = 0,
  ready = 1, // ready for POS
  // > 1 readed by POS
}

/** muss synchron mit PortalCommon.Webshop.PaymentMethods gehalten werden */
export enum paymentMethods {
  AllUnknown = 0,
  BarAbholungLieferung = 1,

  ec = 20,
  ecNational = 21,
  ecInternational = 22,
  ecAusland = 23,
  ecKundenkarte = 24,
  VISA = 25,
  Mastercard = 26,
  Diners = 27,
  AMEX = 28,
  JCB = 29,
  Breuninger = 30,
  ecCash = 31,
  sonstigeKreditkarten = 32,
  AdrevaMacao = 33,
  IKEAFamilyCard = 34,
  VisaDebit = 35,
  MCDebit = 36,
  Maestro = 37,
  VPay = 38,
  Postcard = 39,
  PayPalPicturePayment = 40,
  Einzahlung = 41,
  Auszahlung = 42,
  TWINT = 43,
  WebInvoice = 44,
  ZahlungAnstehend = 45,
  CashController = 46,
  PayPerApp = 47,

  Sofortüberweisung = 49,
  BargeldlosBeiLieferung = 50,
  PayDirect = 51,
  PayPal = 52,

  LunchCard = 60,
  LunchCheckCard = 61,
  MaestroCH = 62,
  PowerCard = 63,
  Loeb = 64,
  Manorcard = 65,
  WIRcard = 66,
  Reka = 67,
  Giftcard = 68,
  ChinaUnionPay = 69,
  AliPay = 70,
  WeChat = 71,
  Sodexo = 72,
  TWINTTerminal = 73,

  OnlineZahlung = 75,

  AmazonPay = 80,
  ApplePay = 81,
  KlarnaPayNow = 82,
  EPS_AT = 83,
  GooglePay = 84,
  Paysafecard = 85,
  Wallet = 86,
  SEPA = 87,
  Discover = 88,
  girocard = 89,

  Webgutscheine = 1001,
  MPA = 1002,
  BargeldlosAbholungLieferung = 1003,

  ZahlenAmPOS = 9999
}

// Requests
/** Bestellung */
export class AddPurchaseOrderDataModel {
  /** hypcusnr, where was ordered  */
  public location: number;
  /** Bestelltyp */
  public ordertype: orderTypes;
  /** Grundpreis. Momentan für interne nutzung/UI vorgesehen, damit es nur einmal berechnet wird */
  public baseprice: number; // TODO auch an YAS übertragen zur möglich prüfung
  /** enthaltener Pfand */
  public deposit: number;
  /** enthaltenes Trinkgeld */
  public tip: number;
  /** enthaltener Rabatt (Achtung ist Positiv) */
  public discountTotal: number;
  /** enthaltene Lieferkosten */
  public deliveryCost: number;
  /** Total zu zahlender Betrag (baseprice - discountTotal + depoit + tip + deliveryCost) */
  public grossprice: number;
  /** Betrag an MwSt */
  public vat: number;
  /** MwSt Auflistung. Momentan für interne nutzung/UI vorgesehen, damit es nur einmal berechnet wird */
  public vatStats: VatStat[]; // TODO auch an YAS übertragen zur möglich prüfung
  /** Language of the user/app */
  public language: string;
  /** CurrencySymbol of the location */
  public currencySymbol: string;
  /** yyyyMMdd, if negative Order is ASAP */
  public wantedHandoverDate: number;
  /** hhmmss, if negative Order is ASAP */
  public wantedHandoverTime: number;
  /** Bemerkung zur Bestellung (limited to 200 Characters) */
  public comment: string;
  /** if anonymous / not registered then = true */
  public cusGuest: boolean;
  // public cusID: number; // Guest = 0
  // public cusNr: string; // Guest = ""
  /** Customer Name (max. 30) */
  public cusName: string;
  /** Customer Vorname (max. 30) */
  public cusFname: string;
  /** Customer Anrede (max. 10) */
  public cusPrefix: string;
  /** Customer Titel (max. 30) */
  public cusTitle: string;
  /** Customer Rechnungsadresse C/O (max. 30) */
  public cusBillCo: string;
  /** Customer Rechnungsadresse Strasse (max. 40) */
  public cusBillAdress: string;
  /** Customer Rechnungsadresse Zusatz (max. 25) */
  public cusBillAddition: string;
  /** Customer Rechnungsadresse PLZ (max. 10) */
  public cusBillPlz: string;
  /** Customer Rechnungsadresse Stadt (max. 30) */
  public cusBillCity: string;
  /** Customer Rechnungsadresse Land (max. 30) */
  public cusBillCountry: string;
  /** Customer Rechnungsadresse Telefonnummer (max. 20) */
  public cusBillTel: string;
  /** Customer Rechnungsadresse E-Mail (max. 63) */
  public cusBillMail: string;
  /** Customer Telefonnummer Primär */
  public tel1: string;
  /** Customer Telefonnummer Sekundär */
  public tel2: string;
  /** Customer Telefonnummer Mobil */
  public telM: string;
  /** Customer Geburtsdatum (YMD) */
  public birth: number;
  // If any cusDelivery* is used, it will be used for delivery
  /** Customer Lieferadresse Token, wenn bereits gespeichert */
  public cusDeliveryToken: string;
  /** Customer Lieferadresse C/O (max. 30) */
  public cusDeliveryCo: string;
  /** Customer Lieferadresse Strasse (max. 40) */
  public cusDeliveryAdress: string;
  /** Customer Lieferadresse Zusatz (max. 25) */
  public cusDeliveryAddition: string;
  /** Customer Lieferadresse PLZ (max. 10) */
  public cusDeliveryPlz: string;
  /** Customer Lieferadresse Stadt (max. 30) */
  public cusDeliveryCity: string;
  /** Customer Lieferadresse Land (max. 30) */
  public cusDeliveryCountry: string;
  /** Customer Lieferadresse Telefonnummer (max. 20) */
  public cusDeliveryTel: string;
  /** Customer Lieferadresse E-Mail (max. 63) */
  public cusDeliveryMail: string;
  /** Primär zu zahlender Betrag */
  public paymentAmount: number;
  /** Sekundär zu zahlender Betrag. Bei Zahlung mit Webgutschein wird es hiermit angegeben */
  public partialPaymentAmount: number;
  /** Web-Gutscheinnummer, um mit Gutschein zu zahlen und/oder Bonuspunkte zu erhalten, oder Buchungsnummer des Paymentpartners */
  public partialpaymentInfo: string;
  /** Zu bestellende/zahlende Artikel. Es sind nur Artikel oder nur Webgutscheine zu setzen. Gemischter Warenkorb ist momentan nicht möglich. */
  public items: AddPurchaseOrderItemDataModel[];
  /** Zu bestellende/zahlende Webgutscheine. Es sind nur Artikel oder nur Webgutscheine zu setzen. Gemischter Warenkorb ist momentan nicht möglich. */
  public webvouchers: AddPurchaseOrderWebvoucherItemDataModel[];
  /** Tisch Code als QR Code bei InHouse Bestellungen */
  public qrCode: string;
  /** Identifikation vom Warenkorb, wird durch den YourAPPServer vergeben */
  public token: string;
  //** Event ID für Überprüfung der Preise */
  public EventID?: number;

  public group_id?: number;
  public group_name?: string;
  public members?: AddPurchaseOrderMemberDataModel[];
}

/** MwSt aufteilung */
export class VatStat {
  /** Prozent, wie 19,00 % */
  public percent: number;
  /** Grundbetrag auf die MwSt zu zahlen ist */
  public assessedAmount: number;
  /** Betrag der MwSt */
  public vat: number;
}

export class AddPurchaseOrderItemDataModel {
  public position: number; // unique position eg 1, 2 or 5
  public product_id: number; // id of the product
  public usingtype: number;
  public count: number; // count of the product
  public product_extras: AddPurchaseOrderItemExtraDataModel[]; // extras for the product
  public comment: string; // comment for the product
  public variable_price: number; // if variable price, the entered price
  public valid_date: number; // entered date for a ticket
  public PE?: number; //angewandte Preisebene für den Artikel
  public bonusactionId: number;
  public benefitId: number;
  public benefitLossId: number;
  public benefitProductId: number;
  public cus_ref_id?: number; // id of the customer reference
  /** only set for coupons that can be redeemed once. */
  public coupon_id?: number | string;
  public coupon_code?: number | string;
  // TODO DEV-131:has not yet added this field to the order connector — unknown fields are silently dropped today
  public redemption_id?: number;
}

export class AddPurchaseOrderMemberDataModel {
  public member_id: number;
  public name: string;
  // server keeps track of this data, but client should not know about this data
  // public account_id?: number;
}

export class AddPurchaseOrderItemExtraDataModel {
  public product_extra_id: number; // id of the product extra
  public count: number; // count of the product extra
}

export class AddPurchaseOrderWebvoucherItemDataModel {
  /** Position im Warenkorb */
  public position: number;
  /** Webgutschein ID */
  public webvoucher_id: number;
  /** Versandart */
  public delivery_type: deliveryTypes;
  /** Anzahl */
  public count: number;
  /** Personenanzahl */
  public person_count: number;
  /** Anzeigen der Personenanzahl */
  public show_person_count: boolean;
  /** kommentar */
  public comment: string;
  /** freier Preis */
  public variable_price: number;
}

export class WebshopSettingsSyncModel2 extends SyncModel {
}

// Responses

/** AddPurchaseOrderModel */
export class AddPurchaseOrderModel {
  public success: boolean;
  public error: number;
  public id: number; // BestellID = Bestellnummer
}

export const WebshopSettingsDMKey: number = 0;

/** Optionen der Reaktion bei nicht Verfügbarkeit der Artikel aufgrund von Zeitsteuerung */
export enum ArticleOptions {
  /** Blendet den Artikel aus */
  hide = 0,
  /** Zeigt Artikel und Hinweis an */
  showHint = 1
}

export class WebshopSettingsDataModel2 extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public information_text_when_leaving: boolean; // If a text should be shown before before
  /** Definition für das json = Eingabefelder in Reservierung */
  public customer_input_fields: string; // ! todo need to remove?
  public article_availability: boolean; // [ArticleAvailability] [bit] NULL,
  public article_availability_minimum: number; // [ArticleAvailabilityMinimum] [int] NULL,
  /** ACHTUNG! ist Obsolete, use OrderType.can_request_tip & request_tip */
  public use_tip: boolean; // ! todo need to remove?
  /** ACHTUNG! ist Obsolete, use OrderType.tip_percentage */
  public percent_tip: number; // ! todo need to remove?
  public deposit_view: DepositView; // [DepositView] [int] NULL,
  public vacation_notification: boolean; // Urlaubsmeldung eingeschaltet?
  public vacation_notification_text: string; // Text für die Urlaubsmeldung
  public recommendation_rules: RecommendationRule[];
  /** @deprecated */ public locations: number[]; // deprecated -> Use MenuSettings.locations instead
  public customer_location_qrCode: CustomerLocationQRCode[];
  public order_day_limit: number;
  public is_vouchercharge_enabled: boolean;
  /** Whether the withdrawal (revoke-order) feature is enabled for this tenant. */
  public use_withdrawal: boolean;
  /** Bedeutet das bei InHouseOrder beim Bestellen nicht sofort Bezahlt werden muss und es später erfolgt */
  public order_inhouse_without_payment: boolean;
  /** Bedeutet das bei InHouseOrder (ausgenommen Gruppenbestellung) nicht selbst Bestellen kann, es ist kann nur Bezahlt werden */
  public payment_inhouse_without_order: boolean;
  public use_asap_delivery: boolean;
  public use_asap_pickup: boolean;
  public is_itemtag_enabled: boolean;
  /** ermöglicht das Filtern nach Artikel TAGs für SOT */
  public is_itemtag_sot_enabled: boolean;
  /** zwingt den Gast beim bestellen zuerst ein Artikel TAG Filter zu setzen am SOT */
  public is_itemtag_sot_forced: boolean;
  public itemtag_type: number; // ! TODO obsolete, es ist immer 0
  public hide_browse: boolean;
  public hide_pickup: boolean;
  public hide_delivery: boolean;
  public hide_inhouse: boolean;
  public hide_voucher: boolean;
  public ordertypes: Ordertype[];
  public use_free_shipping: boolean;
  public free_shipping_threshold: number;
  public delivery_countries: DeliveryCountry[];
  /** verwendung der Menügänge */
  public use_menu_course: boolean;
  /** menügänge, stammdaten */
  public menu_courses: MenuCourse[];
  /** erweiterte Zeitsteuerungs Gruppen */
  public time_sets: TimeSet[];
  /** Feiertage der Standorte */
  public holidays: Holiday[];
  /** verwendung der altersprüfung */
  public use_ask_age: boolean;
  /** erlaubt bei betellung eine Anmerkung beim Artikel zu hinterlegen */
  public use_item_annotation: boolean;
  /** Darstellung auserhalb der Verfügbarkeit durch Zeitsteuerung */
  public article_option: ArticleOptions;
  /** stammdaten zur InHouseOrder */
  public in_house_order: InHouseOrder;
  /** Liste der verbotenen Namen */
  public name_blacklist: string[];
  /** kann Adyen verwenden */
  public has_adyen: boolean;
  /** Erlaubte Adyen Zahlungsmethoden (sind Kommasepariert) */
  public adyen_allowed_payment_types: string;
  /** kann GooglePay von Adyen verwenden */
  public googlePayActive: boolean;
  /** kann Wallee verwenden */
  public has_wallee: boolean;
  /** Webgutschein Einstellungen */
  public webvoucher: Webvoucher;
  /** Coupon Code im WebShop einlösen */
  public use_coupon_code: boolean;
  /** Coupon Code darf gescannt werden */
  public scan_coupon_code: boolean;
  /** Coupon Code zulässige Länge */
  public coupon_code_length: number;
  /** ausgewählte Communities */
  public communities: Community[];
  /** Coupon Code darf gescannt werden */
  public use_poly_map: boolean;
  public img_alt: string;
  /** Events für den WebShop */
  public events: IEvent[];
  /** Definition für das json = Eingabefelder in Patron Registrierung */
  public patron_registration_input_fields: string;
  /** Ist Google API verfügbar */
  public google_api_available: boolean;
  public allow_benefits_in_webshop: boolean;

  public is_calendar_filter_enabled: boolean;
  /**accounting customer data */
  public accounting_customer: AccountingCustomerDataModel;

  public DeserializeSubTypes(): void {
    const me = this;
    // not convertet for performance, because RecommendationRule is simple type
    //if (Array.isArray(me.recommendation_rules)) {
    //  const recommendation_rules = me.recommendation_rules;
    //  for (let i = 0; i < recommendation_rules.length; ++i) {
    //    const recommendation_rule = recommendation_rules[i];
    //    if (Object.getPrototypeOf(recommendation_rule) !== RecommendationRule) {
    //      recommendation_rules[i] = Utils.GetExtend(new RecommendationRule(), recommendation_rule);
    //    }
    //  }
    //}
    // auch deposit_view, recommendation_rules, customer_location_qrCode, delivery_countries, time_sets, holidays sind einfache typen
    if (Array.isArray(me.menu_courses)) {
      const menu_courses = me.menu_courses;
      for (let i = 0; i < menu_courses.length; ++i) {
        const menu_course = menu_courses[i];
        if (Object.getPrototypeOf(menu_course) !== MenuCourse) {
          menu_courses[i] = Utils.GetExtend(new MenuCourse(), menu_course);
        }
      }
    }
    if (Array.isArray(me.ordertypes)) {
      const ordertypes = me.ordertypes;
      for (let i = 0; i < ordertypes.length; ++i) {
        const ordertype = ordertypes[i];
        if (Object.getPrototypeOf(ordertype) !== Ordertype) {
          ordertypes[i] = Utils.GetExtend(new Ordertype(), ordertype);

          if (Array.isArray(ordertypes[i].location_settings)) {
            const location_settings_array = ordertypes[i].location_settings;
            for (let i = 0; i < location_settings_array.length; ++i) {
              const location_settings = location_settings_array[i];
              if (Object.getPrototypeOf(location_settings) !== OrdertypeLocationSettings) {
                location_settings_array[i] = Utils.GetExtend(new OrdertypeLocationSettings(), location_settings);
              }
            }
          }
        }
      }
    }
    // in_house_order ist ein einfacher typ
    if (me.in_house_order && me.in_house_order.landing_page &&
      Object.getPrototypeOf(me.in_house_order.landing_page) !== InHouseOrder_LandingPage) {
      me.in_house_order.landing_page = Utils.GetExtend(new InHouseOrder_LandingPage(), me.in_house_order.landing_page);
    }
    if (me.in_house_order && me.in_house_order.grouporder &&
      Object.getPrototypeOf(me.in_house_order.grouporder) !== InHouseOrder_Grouporder) {
      me.in_house_order.grouporder = Utils.GetExtend(new InHouseOrder_Grouporder(), me.in_house_order.grouporder);
    }
    if (me.webvoucher && Object.getPrototypeOf(me.webvoucher) !== Webvoucher) {
      me.webvoucher = Utils.GetExtend(new Webvoucher(), me.webvoucher);
    }
    if (me.webvoucher && me.webvoucher.landing_page &&
      Object.getPrototypeOf(me.webvoucher.landing_page) !== Webvoucher_LandingPage) {
      me.webvoucher.landing_page = Utils.GetExtend(new Webvoucher_LandingPage(), me.webvoucher.landing_page);
    }
    if (me.accounting_customer &&
      Object.getPrototypeOf(me.accounting_customer) !== AccountingCustomerDataModel) {
      me.accounting_customer = Utils.GetExtend(new AccountingCustomerDataModel(), me.accounting_customer);
    }
    if (Community.isRawArray(me.communities)) {
      const raw = me.communities;
      me.communities = raw.map(Community.fromRaw);
    }
    //TODO EventManager Events
  }
}

export class DeliveryCountry {
  public id: number;
  public country_de: string;
  public country_en: string;
  public minimum_order_value: number;
  public delivery_fee: number;
  public free_shipping_threshold: number;
  public use_free_shipping: boolean;
}

export class RecommendationRule {
  public position: number;
  public label: string;
  public applicable_service: orderTypes;
  public needed_w_grps: number[];
  public missing_w_grps: number[];
  public product_ids: number[];
}

export class CustomerLocationQRCode {
  public locationId: number;
  public tableQRCode: LocationQRCode[];
}

export class LocationQRCode {
  public tableName: string;
  public tableNr: string;
  public qrCode: string;
  public mandatory_Payment: boolean;
}

/** Menügang */
export class MenuCourse implements IMenuCourse {
  /** interne ID, wird bei den Artikeln in der auswahl hinterlegt */
  public id: number;
  /** reihenfolge für die Darestellung */
  public sortnumber: number;
  public de_name: string;
  public en_name: string;
  /** Bezeichnung */
  public get name(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.en_name) ? this.de_name : this.en_name;
  }
}

/** Erweiterte Zeitsteuerungs Gruppe */
export class TimeSet {
  /** interne ID, wird bei den Artikeln in der auswahl hinterlegt */
  public id: number;
  /** Die Tage liegen im Array bereits sortiert nach TimeSetDay, so kann direkt auf das Aray zugeriffen werden
   *  Es hat auch eine länge von genau 8 (Feiertag und Mo-So) */
  public days: TimeSetDate[];
}

/** Wochentag + Feiertag */
export class TimeSetDate {
  /** Wochentag bzw. Feiertag */
  public day: TimeSetDay;
  /** Wird genutzt für den Tag */
  public active: boolean;
  /** Nur Buchbar von der Zeit */
  public from_time_hms: number;
  /** Nur Buchbar bis zur Zeit */
  public to_time_hms: number;
  /** Anzeige Text DE, wenn nicht in dem Zeitraum */
  public resp_txt: string; // todo sollte bei möglichkeit zu resp_txt_de umbenannt werden
  /** Anzeige Text EN, wenn nicht in dem Zeitraum */
  public resp_txt_en: string;
}

/** Feiertage je Standort */
export class Holiday {
  /** interne POS ID, wird nicht genutzt */
  public id: number;
  /** location = hyp_cus_nr */
  public location: number;
  /** Begin des Feiertags */
  public begin_date_ymd: number;
  /** Ende des Feiertags */
  public end_date_ymd: number;
  /** momentan nicht weiter berückschtigt */
  public begin_time_hms: number;
  /** momentan nicht weiter berückschtigt */
  public end_time_hms: number;
}

/** InHouseOrder stammdaten */
export class InHouseOrder {
  /** alle Locations beim InHouse auf den standort der geräte prüfen, siehe gps_radius */
  public check_gps: boolean;
  /** wenn check_gps=true wird das device geprüft und muss isch in diesem radius (angabe in metern) befinden um zu bestellen */
  public gps_radius: number;
  /** verwendung von ePing (digitalem Pager) bei allen Standorten gewünscht, sonst use_eping_locations beachten */
  public use_eping_all_locations: boolean;
  /** verwendung von ePing (digitalem Pager) an bestimmten Standorten gewünscht */
  public use_eping_locations: number[];
  /** InHouse Landing Page Einstellungen */
  public landing_page: InHouseOrder_LandingPage;
  /** InHouse Gruppenbestellung Einstellungen */
  public grouporder: InHouseOrder_Grouporder;
}

/** Landingpage Stammdaten zur InHouseOrder */
export class InHouseOrder_LandingPage {
  /** Überschrift image_label verwenden */
  public use_image_label: boolean;
  public image_label_de: string;
  public image_label_en: string;
  /** text beim bild */
  public get image_label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.image_label_en) ? this.image_label_de : this.image_label_en;
  }
  public pay_label_de: string;
  public pay_label_en: string;
  /** bezahlen knopf schrift */
  public get pay_label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.pay_label_en) ? this.pay_label_de : this.pay_label_en;
  }
  public pay_subtext_de: string;
  public pay_subtext_en: string;
  /** bezahlen knopf anmerkung */
  public get pay_subtext(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.pay_subtext_en) ? this.pay_subtext_de : this.pay_subtext_en;
  }
  public order_label_de: string;
  public order_label_en: string;
  /** bestellen knopf schrift */
  public get order_label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.order_label_en) ? this.order_label_de : this.order_label_en;
  }
  public order_subtext_de: string;
  public order_subtext_en: string;
  /** bestellen knopf anmerkung */
  public get order_subtext(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.order_subtext_en) ? this.order_subtext_de : this.order_subtext_en;
  }
  public service_call_label_de: string;
  public service_call_label_en: string;
  /** serviceruf knopf schrift */
  public get service_call_label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.service_call_label_en) ? this.service_call_label_de : this.service_call_label_en;
  }
  public service_call_subtext_de: string;
  public service_call_subtext_en: string;
  /** serviceruf knopf anmerkung */
  public get service_call_subtext(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.service_call_subtext_en) ? this.service_call_subtext_de : this.service_call_subtext_en;
  }
  public my_order_group_label_de: string;
  public my_order_group_label_en: string;
  /** Meine Bestellungs Gruppe knopf schrift */
  public get my_order_group_label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.my_order_group_label_en) ? this.my_order_group_label_de : this.my_order_group_label_en;
  }
  public my_order_group_subtext_de: string;
  public my_order_group_subtext_en: string;
  /** Meine Bestellungs Gruppe knopf anmerkung */
  public get my_order_group_subtext(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.my_order_group_subtext_en) ? this.my_order_group_subtext_de : this.my_order_group_subtext_en;
  }
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  /** letzter änderungstermin vol bild */
  public get last_image_update_at(): moment.Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  /** url zum bild, vorprüfung last_image_update_at_ymd > 0 notwendig  */
  public get image_photo(): string {
    return ContentType.Inhouse_Landingpage_Image + "/" + 0 /* 0 weil es nur das bild gibt */ + "_photo_" + ImageOrientation.Landscape + "/" + this.last_image_update_at_ymd + "/" + this.last_image_update_at_hms;
  }
}

/** Gruppenbestellung Einstellung zur InHouseOrder */
export class InHouseOrder_Grouporder {
  /** Gruppenbestellung soll verwendet werden */
  public is_active: boolean;
  /** maximale anzahl von mitgliedern in der gruppe */
  public participants_per_group: number;
  /** verwenden vom welcome_text caption und description */
  public use_welcome_text: boolean;
  public welcome_text_caption_de: string;
  public welcome_text_caption_en: string;
  /** willkommens text - titel */
  public get welcome_text_caption(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.welcome_text_caption_en) ? this.welcome_text_caption_de : this.welcome_text_caption_en;
  }
  public welcome_text_description_de: string;
  public welcome_text_description_en: string;
  /** willkommens text - beschreibung */
  public get welcome_text_description(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.welcome_text_description_en) ? this.welcome_text_description_de : this.welcome_text_description_en;
  }
  public single_order_label_de: string;
  public single_order_label_en: string;
  /** Einzel-/Tischbestellung Button Überschrift */
  public get single_order_label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.single_order_label_en) ? this.single_order_label_de : this.single_order_label_en;
  }
  public single_order_subtext_de: string;
  public single_order_subtext_en: string;
  /** Einzel-/Tischbestellung Button Text */
  public get single_order_subtext(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.single_order_subtext_en) ? this.single_order_subtext_de : this.single_order_subtext_en;
  }
  public group_order_label_de: string;
  public group_order_label_en: string;
  /** Gruppenbestellung Button Überschrift */
  public get group_order_label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.group_order_label_en) ? this.group_order_label_de : this.group_order_label_en;
  }
  public group_order_subtext_de: string;
  public group_order_subtext_en: string;
  /** Gruppenbestellung Button Text */
  public get group_order_subtext(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this.group_order_subtext_en) ? this.group_order_subtext_de : this.group_order_subtext_en;
  }
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  /** letzter änderungstermin vom bild */
  public get last_image_update_at(): moment.Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  /** url zum bild, vorprüfung (last_image_update_at_ymd > 0) = notwendig */
  public get image_photo(): string {
    return ContentType.Inhouse_GroupOrder_Image + "/" + 0 /* 0 weil es nur das bild gibt */ + "_photo_" + ImageOrientation.Landscape + "/" + this.last_image_update_at_ymd + "/" + this.last_image_update_at_hms;
  }

}

/** Webgutschein Einstellungen */
export class Webvoucher {
  /** Anzahl der Personen im Webguschein ist aktiviert */
  public number_of_persons_enable: boolean;
  /** Postversand Optionen */
  public delivery_settings: WebvoucherDeliverySettings;
  /** Postversand Kosten in Cents */
  public delivery_price: number;
  /** POS hat Eine Webgutschein ID und kann Bestellungen entgegen nehmen */
  public pos_webvoucher_id: number;
  /** Webgutschein Landing Page Einstellungen */
  public landing_page: Webvoucher_LandingPage;
  public charge_last_image_update_at_ymd: number;
  public charge_last_image_update_at_hms: number;
  /** letzter änderungstermin vom bild für gutscheinaufladung */
  public get charge_last_image_update_at(): moment.Moment {
    return Utils.GetMomentFromInt(this.charge_last_image_update_at_ymd, this.charge_last_image_update_at_hms);
  }
  /** url zum bild für gutscheinaufladung, vorprüfung charge_last_image_update_at_ymd > 0 notwendig  */
  public get charge_image_photo(): string {
    return ContentType.Webvoucher_Charge_Image + "/" + 0 /* 0 weil es nur das bild gibt */ + "_photo_" + ImageOrientation.Landscape + "/" + this.charge_last_image_update_at_ymd + "/" + this.charge_last_image_update_at_hms;
  }
}

/** Landingpage zum Webgutschein */
export class Webvoucher_LandingPage {
  public label_de: string;
  public label_en: string;
  /** Bezeichnung */
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public subtext_de: string;
  public subtext_en: string;
  /** Erweiterte Bezeichnung */
  public get subtext(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.subtext_en) ? this.subtext_de : this.subtext_en;
  }
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  /** letzter änderungstermin vol bild */
  public get last_image_update_at(): moment.Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  /** url zum bild, vorprüfung last_image_update_at_ymd > 0 notwendig  */
  public get image_photo(): string {
    return ContentType.Webvoucher_Landingpage_Image + "/" + 0 /* 0 weil es nur das bild gibt */ + "_photo_" + ImageOrientation.Landscape + "/" + this.last_image_update_at_ymd + "/" + this.last_image_update_at_hms;
  }
}

export class Ordertype {
  public id: number;
  public default_label_de: string;
  public default_label_en: string;
  public sortiment: string;
  public default_pe: number;
  public sort_nr: number;
  public show_on_startpage: boolean;
  public show_in_location: boolean;
  /** tip ist im ordertype erlaubt
   * Achtung request_tip beachten
   */
  public can_request_tip: boolean; // todo was ist richtig can_request_tip oder request_tip
  /** tip soll verwendet werden
   * Achtung can_request_tip beachten
  */
  public request_tip: boolean; // todo was ist richtig can_request_tip oder request_tip
  public tip_percentage: number;
  public can_webvoucher: boolean;
  public can_cash: boolean;
  public can_cashless: boolean;
  public can_accounting: boolean;
  public can_paypal: boolean;
  public can_hypersoftpay: boolean;
  public use_webvoucher: boolean;
  public use_cash: boolean;
  public use_cashless: boolean;
  public use_accounting: boolean;
  public use_paypal: boolean;
  public use_hypersoftpay: boolean;
  public UseItemAnnotation: boolean;
  public AnnotationDescription_DE: string;
  public AnnotationDescription_EN: string;
  public AnnotationPlaceholder_DE: string;
  public AnnotationPlaceholder_EN: string;
  public label_de: string;
  public label_en: string;
  public description_de: string;
  public description_en: string;
  public customer_input_fields: string;
  public multi_selection: boolean;
  public UseBasketComment: boolean;
  public UseMandatoryAddressVerification: boolean;
  /** Standort abweichende Einstellungen */
  public location_settings: OrdertypeLocationSettings[];
  public PayAtWaiter: boolean;
  /** Blacklist von `HypCusNr`, an denen "an der Kasse" ausgeblendet wird; leer/fehlend = kein Ausschluss; kann von älteren Servern fehlen */
  public PayAtWaiterExcludedLocations: number[];
}

/** Standort Einstellungen für Bestelltyp */
export class OrdertypeLocationSettings {
  /** Standort */
  public location: number;
  /** Extra Text für Besetllbestätigung (De) */
  public order_confirmation_extra_text_de: string;
  /** Extra Text für Besetllbestätigung (En) */
  public order_confirmation_extra_text_en: string;
  /** Extra Text für Besetllbestätigung */
  public get order_confirmation_extra_text(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.order_confirmation_extra_text_en) ? this.order_confirmation_extra_text_de : this.order_confirmation_extra_text_en;
  }
  public digipager_optional_text_de: string;
  /** Extra Text für Besetllbestätigung (En) */
  public digipager_optional_text_en: string;
  /** Extra Text für Besetllbestätigung */
  public get digipager_optional_text(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.digipager_optional_text_en) ? this.digipager_optional_text_de : this.digipager_optional_text_en;
  }

}

export class OrdertypeViewModel {
  public get id(): orderTypes {
    return this._model.id;
  }
  public get iconFilename(): string {
    return this._settingsModel.iconFilename;
  }
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.label_en) ? this._model.label_de : this._model.label_en;
  }
  public get description(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.description_en) ? this._model.description_de : this._model.description_en;
  }
  private _locationIDs: number[];
  /** All IDs of Location that support this service */
  public get locationIDs(): number[] {
    return this._locationIDs;
  }
  /** Is supported by any Location */
  public get supported(): boolean {
    return this._locationIDs.length > 0;
  }
  /** zu nutzendes Sortimnent */
  public get sortiment(): string {
    return this._model.sortiment;
  }
  /** barzahlen beim Kellner im Inhaus */
  public get PayAtWaiter(): boolean {
    return this._model.PayAtWaiter;
  }
  /** Standorte (`HypCusNr`), an denen "an der Kasse" ausgeblendet wird; nie `undefined`, fehlendes/ungültiges Feld ergibt `[]` */
  public get PayAtWaiterExcludedLocations(): number[] {
    const me = this;
    return Array.isArray(me._model.PayAtWaiterExcludedLocations) ? me._model.PayAtWaiterExcludedLocations : [];
  }
  /**
   * Einzige Regel für die Verfügbarkeit von "an der Kasse" an einem Standort.
   * `PayAtWaiter=false` schlägt jede Liste; ein leerer `locationID` gilt als nicht ausgeschlossen.
   */
  public isPayAtWaiterAvailableAt(locationID: number | null | undefined): boolean {
    const me = this;
    if (!me.PayAtWaiter) {
      return false;
    }
    if (locationID === null || locationID === undefined) {
      return true;
    }
    return !me.PayAtWaiterExcludedLocations.includes(locationID);
  }
  /** initial anzuwendende Preisebene */
  public get default_pe(): number {
    return this._model.default_pe;
  }
  /** Reiehnfolge für den Bestelltyp */
  public get sort_nr(): number {
    return this._model.sort_nr;
  }
  /** Anzeigen auf dem Startscreen */
  public get show_on_startpage(): boolean {
    return this._model.show_on_startpage;
  }
  /** Anzeigen in den Deteils des Standorts */
  public get show_in_location(): boolean {
    return this._model.show_in_location;
  }
  /** Ist eine Trinkgeld abfrage möglich (ob auf gewünscht, dazu request_tip nutzen) */
  public get can_request_tip(): boolean {
    return this._model.can_request_tip;
  }
  /** soll Trinkgeld abgefragt werden (mit can_request_tip kann man vorab prüfen ob es überhaupt möglich ist) */
  public get request_tip(): boolean {
    return this._model.request_tip;
  }
  /** Initial vorgeschlagener Prozentsatz für Trinkgeld */
  public get tip_percentage(): number {
    return this._model.tip_percentage;
  }
  /** Ist es möglich mit Webgutschein zu zahlen (ob gewünscht, dazu use_webvoucher nutzen) */
  public get can_webvoucher(): boolean {
    return this._model.can_webvoucher;
  }
  /** Ist es möglich mit Bargeld zu zahlen (ob gewünscht, dazu use_cash nutzen) */
  public get can_cash(): boolean {
    return this._model.can_cash;
  }
  /** Ist es möglich mit Bargeldlos zu zahlen (ob gewünscht, dazu use_cashless nutzen) */
  public get can_cashless(): boolean {
    return this._model.can_cashless;
  }
  /** Ist es möglich mit MPA zu zahlen (ob gewünscht, dazu use_accounting nutzen) */
  public get can_accounting(): boolean {
    return this._model.can_accounting;
  }
  /** Ist es möglich mit PayPal zu zahlen (ob gewünscht, dazu use_paypal nutzen) */
  public get can_paypal(): boolean {
    return this._model.can_paypal;
  }
  /** Ist es möglich mit HypersoftPay zu zahlen (ob gewünscht, dazu use_hypersoftpay nutzen) */
  public get can_hypersoftpay(): boolean {
    return this._model.can_hypersoftpay;
  }
  /** Soll mit Webgutschein bezahlt werden können (mit can_webvoucher kann man vorab prüfen ob es überhaupt möglich ist) */
  public get use_webvoucher(): boolean {
    return this._model.use_webvoucher;
  }
  /** Soll mit Bargeld bezahlt werden können (mit can_cash kann man vorab prüfen ob es überhaupt möglich ist) */
  public get use_cash(): boolean {
    return this._model.use_cash;
  }
  /** Soll mit Bargeldlos bezahlt werden können (mit can_cashless kann man vorab prüfen ob es überhaupt möglich ist) */
  public get use_cashless(): boolean {
    return this._model.use_cashless;
  }
  /** Soll mit MPA bezahlt werden können (mit can_accounting kann man vorab prüfen ob es überhaupt möglich ist) */
  public get use_accounting(): boolean {
    return this._model.use_accounting;
  }
  /** Soll mit PayPal bezahlt werden können (mit can_paypal kann man vorab prüfen ob es überhaupt möglich ist) */
  public get use_paypal(): boolean {
    return this._model.use_paypal;
  }
  /** Soll mit HypersoftPay bezahlt werden können (mit can_hypersoftpay kann man vorab prüfen ob es überhaupt möglich ist) */
  public get use_hypersoftpay(): boolean {
    return this._model.use_hypersoftpay;
  }
  public get customer_input_fields_JSON(): string {
    return this._model.customer_input_fields;
  }

  public get use_item_annotation(): boolean {
    return this._model.UseItemAnnotation;
  }

  public get annotation_title(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.AnnotationDescription_EN) ? this._model.AnnotationDescription_DE : this._model.AnnotationDescription_EN;
  }
  public get annotation_placeholder(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this._model.AnnotationPlaceholder_EN) ? this._model.AnnotationPlaceholder_DE : this._model.AnnotationPlaceholder_EN;

  }

  private _customer_input_fields: Object[] = undefined;
  /** return customer_input_fields als object sonst null */
  public get customer_input_fields(): Object[] {
    if (this._customer_input_fields === undefined) {
      if (this.customer_input_fields_JSON !== "") {
        this._customer_input_fields = JSON.parse(this.customer_input_fields_JSON);
      } else {
        this._customer_input_fields = null;
      }
    }
    return this._customer_input_fields;
  }

  /** Ob der Servicetype den Warenkorb auf dem YourAPPServer ablegt: nur inhaus */
  public get useYASBasket(): boolean {
    return !!this._settingsModel.useYASBasket;
  }

  /** Soll das Kommentarfeld im Checkoutbereich Angezeigt werden */
  public get UseBasketComment(): boolean {
    return this._model.UseBasketComment;
  }

  public get UseMandatoryAddressVerification(): boolean {
    return this._model.UseMandatoryAddressVerification;
  }

  private _model: Ordertype;
  private _settingsModel: OrdertypeSettings;

  public get model(): Ordertype {
    return this._model;
  }

  public get settingsModel(): OrdertypeSettings {
    return this._settingsModel;
  }

  constructor(model: Ordertype, settings: OrdertypeSettings, locationIDs: number[]) {
    this._model = model;
    this._settingsModel = settings;
    this._locationIDs = locationIDs;
  }
}

export class WebshopSettingsSyncDataModel2 extends SyncDataModel {
  public settings: WebshopSettingsDataModel2[];
  public get models(): DataModel[] { return this.settings; }
  public DeserializeType(): void {
    this._DeserializeType(WebshopSettingsDataModel2);
  }
}
